import { render, staticRenderFns } from "./geological.vue?vue&type=template&id=3e5063be&scoped=true&"
import script from "./geological.vue?vue&type=script&lang=js&"
export * from "./geological.vue?vue&type=script&lang=js&"
import style0 from "./geological.vue?vue&type=style&index=0&id=3e5063be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5063be",
  null
  
)

export default component.exports